<template>
  <div>
    <h1>Manage Bucket Users - {{bucketName}}</h1>

    <div class="row">
      <div class="col-sm">

        <b-link href="/bucket" style="display:block; margin-bottom:20px;">Return to Bucket List</b-link>

      </div>
    </div>

    <div class="row">
      <div class="col-sm">

        <b-button variant="primary" style="margin-bottom:20px;" v-b-modal.modal-crud>New Bucket User</b-button>

      </div>
    </div>

    <b-modal id="modal-crud" hide-header hide-footer>
      <h2>{{formTitle}}</h2>
      <hr/>
      <form ref="form" @submit.prevent="save">
        <b-form-group 
            label="Keycloak User Id" label-for="user-name-input" 
            invalid-feedback="Keycloak User Id is required">
            <b-form-input id="user-name-input" 
              v-model="$v.editedItem.userId.$model" 
              :state="$v.editedItem.userId.$dirty ? !$v.editedItem.userId.$error : null"
              aria-describedby="input-1-live-feedback"
              required>
            </b-form-input> 
            <b-form-invalid-feedback id="input-1-live-feedback">
              This is a required field.
            </b-form-invalid-feedback>     
            <b-form-text id="user-name-input-help">Required.</b-form-text> 
        </b-form-group>

        <b-card  header-tag="header" style="margin-bottom:18px;">
         <template v-slot:header>
            <strong>Bucket Permissions</strong>
          </template>
          <b-form-checkbox v-model="$v.editedItem.list.$model" name="list-input" switch>
            List Objects
          </b-form-checkbox>
          <b-form-checkbox v-model="$v.editedItem.upload.$model" name="upload-input" switch>
            Upload Objects
          </b-form-checkbox>
          <b-form-checkbox v-model="$v.editedItem.download.$model" name="download-input" switch>
            Download Objects
          </b-form-checkbox>
          <b-form-checkbox v-model="$v.editedItem.delete.$model" name="delete-input" switch>
            Delete Objects
          </b-form-checkbox>
          <b-form-checkbox v-model="$v.editedItem.tag.$model" name="tag-input" switch>
              Tag Objects
          </b-form-checkbox>
          <b-form-checkbox v-model="$v.editedItem.viewTag.$model" name="view-tag-input" switch>
              View Tags
          </b-form-checkbox>
         </b-card>
        

          <b-button @click="close" style="margin-right:15px;">Cancel</b-button>
          <b-button type="submit" variant="primary" :disabled="$v.editedItem.$invalid">Save</b-button>
        </form>
    </b-modal>

    

    <div class="row">
      <div class="col-sm">
        <b-table hover small responsive show-empty
          :fields="fields"
          :items="users"
          :busy="isLoading">
          <template v-slot:cell(actions)="row">
            <b-button size="sm" @click="editItem(row.item)" class="mr-1">
              edit
            </b-button>
            <b-button size="sm" @click="removeItem(row.item)" class="mr-1">
                remove
            </b-button>
            <b-button size="sm" @click="setBucketAdmin(row.item)" v-if="isAdmin() && !row.item.isBucketAdmin" class="mr-1">
                set as bucket admin
            </b-button>
            <b-button size="sm" @click="removeBucketAdmin(row.item)" v-if="isAdmin() && row.item.isBucketAdmin" class="mr-1">
                remove bucket admin
            </b-button>
          </template>

          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>

          <template v-slot:empty="scope">
            <p>No bucket users found.</p>
          </template>

          <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
            <strong>Loading, Please Wait...</strong>
          </div>        
        </b-table>
      </div>
    </div>

  </div>
</template>

<script>
  import config from '@/config'
  import axios from 'axios';
  import axiosRetry from 'axios-retry';
  import { validationMixin } from 'vuelidate'
  import { required, minLength } from 'vuelidate/lib/validators'

  axiosRetry(axios, { retries: 3 });

  export default {
    mixins: [validationMixin],
    props: [
        'id',
        'bucketName'
    ],
    
    data: () => ({
      isLoading: false,

      fields: [
        {key: 'userId', sortable: true, label: 'User Id'},
        {key: 'upload', sortable: true, label: 'Upload'},
        {key: 'list', sortable: true, label: 'List'},
        {key: 'download', sortable: true, label: 'Download'},
        {key: 'delete', sortable: true, label: 'Delete'},
        {key: 'tag', sortable: true, label: 'Tag'},
        {key: 'viewTag', sortable: true, label: 'View Tags'},
        {key: 'isBucketAdmin', sortable: true, label: 'Bucket Admin'},
        {key: 'actions', label: 'Actions'}
      ],
      users: [],
      options: {
          format: 'YYYY-MM-DD',
          useCurrent: false,
      },
      editedIndex: -1,
      editedItem: {
        userId: null,
        bucketId: null,
        upload: false,
        list: false,
        delete: false,
        download: false,
        tag: false,
        viewTag: false,
      },
      defaultItem: {
        userId: null,
        bucketId: null,
        upload: false,
        list: false,
        delete: false,
        download: false,
        tag: false,
        viewTag: false,
      },    
    }),

    validations: {
      editedItem: {
        userId: { required, },
        bucketId: {  },
        list: { required, },
        upload: { required, },
        delete: { required, },
        download: { required, },
        tag: { required },
        viewTag: { required },
      }
    },

    created () {
      this.initialize()
    },

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Bucket User' : 'Edit Bucket User'
      }
    },



    methods: {
      isAdmin() {
          return this.$keycloak.hasResourceRole('admin')
      },
      fetchUsers() {
        var url = `${config.CLOUDDRIVE_API_ENDPOINT}bucketusers/${this.id}`
          axios.get(url)
            .then(response => {
                this.users = response.data
                this.isLoading = false
            })
      },

      initialize() {
          this.isLoading = true
          this.fetchUsers()
      },

      close() {
        this.$bvModal.hide('modal-crud')
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          this.fetchUsers()
        }, 300)
      },

      editItem (item) {
        this.editedIndex = this.users.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$bvModal.show('modal-crud')
      },

      save() {
        this.editedItem.bucketId = this.id
        if (this.editedIndex > -1) {
            axios.put(config.CLOUDDRIVE_API_ENDPOINT + 'bucketuser', this.editedItem)
            .then(response => { 
              this.fetchUsers()
                this.$bvToast.toast('Bucket User Updated', {
                  title: 'Status',
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: 'success',
                  appendToast: true
                }) 
            });
          
        } else {
            axios.post(config.CLOUDDRIVE_API_ENDPOINT + 'bucketuser', this.editedItem)
            .then(response => { 
              this.fetchUsers()
                this.$bvToast.toast('Bucket User Saved', {
                  title: 'Status',
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: 'success',
                  appendToast: true
                }) 
            });
          
        }
        this.close()
      },

      removeItem (item) {
        var outcome = ''
        this.$bvModal.msgBoxConfirm(
            `Please confirm that you want to remove the user ${item.userId} from this bucket.`, {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'YES',
                cancelTitle: 'NO',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                outcome = value
                if (value) {
                    axios.delete(config.CLOUDDRIVE_API_ENDPOINT + 'bucketuser', {data: { payload: item }})
                        .then(response => {
                            this.fetchUsers()
                            this.$bvToast.toast('Bucket User Removed', {
                                title: 'Status',
                                toaster: 'b-toaster-top-center',
                                solid: true,
                                variant: 'success',
                                appendToast: true
                            })
                        })
                } else {
                    this.$bvModal.hide
                }
            })
      },

      setBucketAdmin(item) {
          axios.post(`${config.CLOUDDRIVE_API_ENDPOINT}bucketusers/bucketAdmin/` + true, item)
              .then(response => {
                  this.fetchUsers()
              })
      },

      removeBucketAdmin(item) {
          axios.post(`${config.CLOUDDRIVE_API_ENDPOINT}bucketusers/bucketAdmin/`+ false, item)
              .then(response => {
                  this.fetchUsers()
              })
      },

    }
  }
</script>